import { dynamic } from '#/utils/dynamic';

export const DynamicSearchJobsRefinements = dynamic(
  () =>
    import('./SearchJobsRefinements').then((m) => ({
      default: m.SearchJobsRefinements,
    })),
  { strategy: 'client-only' },
);
